export const config = {
  api: {
    baseURL: '/api',
  },
};

export type Config = typeof config;
